'use strict';

const zIndices = {
    tableFilter: 9,
    drawer: 400,
    overlay: 700,
    modal: 500,
    toaster: 2000,
    tooltip: 800,
};

exports.zIndices = zIndices;
//# sourceMappingURL=z-indices.js.map
